import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationDialogService } from '../../confirmation-dialog/confirmation-dialog.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { DhukanDataService } from 'src/app/services/dhukan/dhukan-data.service';
import { LoginDataService } from 'src/app/services/dhukan/login-data.service';
import { ActivatedRoute } from '@angular/router';
@Component({
  selector: 'app-addkitchennotes',
  templateUrl: './addkitchennotes.component.html',
  styleUrls: ['./addkitchennotes.component.css']
})
export class AddkitchennotesComponent implements OnInit  {

  //Mode Values
  isaddmode: boolean = false;
  iseditmode: boolean = false;
  isdeletemode: boolean = false;
  isviewmode: boolean = false;

  saveloading: boolean;
  //Save Validation
  submitted: boolean;
  successfully: boolean;


  //Edit Get Values
  kitchennotesColl: any = [];
 

  countryColl: any = [];
  stateColl: any = [];
  //pageColl:any=[];

  kitchennotesform = new FormGroup({
    kitchennotesid: new FormControl(0),
    kitchennotesname: new FormControl('', Validators.required),
    inactive: new FormControl(false),
  });

  isloading: boolean = false;
  isprivilage: boolean = false;
  showProgress: boolean = false;
  formname: String = "Kitchennotes";

  @Input() kitchennotesid: number = 0
  @Input() kitchennotesname: any = '';
  @Output() emitData = new EventEmitter();

  constructor(private toastr: ToastrService, private appService: DhukanDataService, private route: ActivatedRoute,
    private loginService: LoginDataService, private activeModal: NgbActiveModal, private confirmationDialogService: ConfirmationDialogService) {
    this.route.queryParams.subscribe(params => {
      if (params.id !== undefined) {
        this.kitchennotesid = params.id
      }
    });
    this.fnServiceChanges();
  }

  fnServiceChanges() {
    this.loginService.serviceloginChange.subscribe((value) => {
      if (this.loginService.fnCheckCompany()) {
      if (this.loginService.fnCheckUser()) {

        if (this.fnCheckUserPririvilage()) {
          this.isloading = true;
          this.fnOnInitForm();
        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.loginService.fnCompanyFaildRedirect();
      }         
      }
      else {
        this.fnUserFailedForm();
      }
    });
  }

  ngOnInit() {
    try {
      if (this.loginService.fnCheckCompany()) {
      if (this.loginService.fnCheckUser()) {
        if (this.fnCheckUserPririvilage()) {
          this.isloading = true;
          this.fnOnInitForm();
        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.loginService.fnGetUserRoleList();
      }
    }
    else {
      this.loginService.fnCompanyFaildRedirect();
    }         
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }
  ngAfterViewInit(){
 
    this.loginService.fnSetFirstControlFocus('kitchennotesname');
  }
  fnOnInitForm() {
    try {
      this.isaddmode = true;
      this.kitchennotesform.reset();
      this.fnInitializeKitchennotes();

      if (this.kitchennotesid > 0) {
        this.fngetKitchennotes();
      }
    
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }



  fnCheckUserPririvilage() {
    var _check: boolean = false;
    if (this.kitchennotesid > 0) {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'ALTER')
    } else {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'CREATE')
    }

    return _check;
  }

  fnUserFailedForm() {
    this.isprivilage = true;
  }


  fnInitializeKitchennotes() {
    this.kitchennotesform.setValue({

      kitchennotesid: 0,
      kitchennotesname: '',
      inactive:false,
    })
  }
 
  //Get 
  fngetKitchennotes() {
   
    var data = {
      'kitchennotesid': this.kitchennotesid,
      'companyid': this.loginService.fnGetCompanyId(),
      'organizationid': this.loginService.fnGetOrganizationId(),
    }
    this.appService.getKitchennotes(data)
      .subscribe(
        (res) => {
          this.kitchennotesColl = res.json().result;
          var editdata = this.kitchennotesColl[0];
          this.fnEditMode(editdata);
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }


  //Save Btn Click
  fnSaveBtnClick() {
 
    try {
      if (this.saveloading) {
        return;
      }
      this.submitted = true;
      this.successfully = false;
      //Validate
      if (this.kitchennotesform.valid) {
        this.saveloading = true;
        //Check
        var data = {
          'kitchennotesid': this.kitchennotesid,
          'kitchennotesname': this.kitchennotesform.get('kitchennotesname').value,
          'companyid': this.loginService.fnGetCompanyId(),
          'organizationid': this.loginService.fnGetOrganizationId(),
          'inactive': this.kitchennotesform.get('inactive').value,
          'createdby': this.loginService.fnGetModUserId(),
          'modifiedby': this.loginService.fnGetModUserId(),
        }
      
        this.appService.fnCheckKitchennotes(data).subscribe(
          (res) => {
            //console.log(res)
            var _checkresult = res.json().result[0].checkfield;

            if (_checkresult === "done") {
              if (this.kitchennotesform.get('kitchennotesid').value > 0) {
                //Update Department
                this.fnSetKitchennotes(data);
              }
              else {
                //Insert Department
                this.fnInsertKitchennotes(data);
              }
            }
            else {
              if (_checkresult === "name") {
                this.saveloading = false;
                this.kitchennotesform.controls['kitchennotesname'].setErrors({ 'notfound': true });
              }
            }
          },
          (err) => {
            this.saveloading = false;
            this.toastr.error('Error', err);
          });
      }
    } catch (ex) {
      this.saveloading = false;
      this.fnShowErrorMsg(ex);
    }
  }

  //Insert
  fnInsertKitchennotes(data) {
  
    this.appService.fnInsertKitchennotes(data).subscribe(
      (res) => {
        this.saveloading = false;
        if (res.json().status === 200) {

          var result = res.json().result;

          var rtnkitchennotesid = 0;
          if (result.length > 0) {
            rtnkitchennotesid = result[0].kitchennotesid
           
          }
          this.toastr.success('', "The new kitchennotes has been added successfully.Insert Successfully");

          this.fnInsertActivityLog('INSERT', 0, data.kitchennotesid);

          this.emitData.emit(rtnkitchennotesid);
          this.activeModal.close(true);
        }
      },
      (err) => {
        this.saveloading = false;
        this.toastr.error('Error', err);
      });

  }

  //Set
  fnSetKitchennotes(data) {

    this.appService.fnSetKitchennotes(data).subscribe(
      (res) => {
        this.saveloading = false;
        if (res.json().result != "") {
          this.toastr.success('', "The kitchennotes has been updated successfully.");

          this.fnInsertActivityLog('EDIT', this.kitchennotesid, data.kitchennotesname);

          this.emitData.emit(this.kitchennotesid);
          this.activeModal.close(true);
        }
      },
      (err) => {
        this.saveloading = false;
        this.toastr.error('Error', err);
      });

  }



  private fnEditMode(deptBO) {

    this.kitchennotesform.setValue({

      kitchennotesid: deptBO.kitchennotesid,
      kitchennotesname: deptBO.kitchennotesname,
      inactive: deptBO.inactive,
    });

    this.isaddmode = false;
    this.iseditmode = true;
    this.isdeletemode = false;
    this.isviewmode = false;
  }



  fnInsertActivityLog(action, refno, desc) {
    try {
      var data = {
        logtype: action,
        logat: this.formname,
        refnum: refno,
        logdescr: desc,
        logby: this.loginService.fnGetModUserId(),
        'companyid': this.loginService.fnGetCompanyId(),

      }


       this.appService.fnInsertActivity(data).subscribe(
         (res)=>{
         },
         (err)=>{

         });

    } catch {

    }
  }



  public decline() {
    this.activeModal.close(false);
  }



  private fnShowErrorMsg(ex) {
    this.toastr.warning('Internal Error', ex);
  }





}
